module.exports = __webpack_public_path__ + "static/media/Landing_page_Banner_Mobile@1x.aa03390f.webp";